import { RequiredAsteriskProps } from './RequiredAsterisk.types';

const RequiredAsterisk: React.FC<RequiredAsteriskProps> = ({ dataTestId = 'required-indicator' }) => (
  <span data-test-id={dataTestId} className="text-pinkRed-500 body-lg ml-2.5">
    &bull;
  </span>
);

export default RequiredAsterisk;
